// Child lists can contain `{ divider: true }` markers (see TABLE_MENU_GROUPS). After items are
// filtered away (NHS hidden for practices without NHS, feature-gated entries, hidden_nav_items)
// a marker can end up first, last or doubled — draw only the ones that separate two real items.
export const tidyDividers = (items = []) => {
    const out = [];
    items.forEach((item) => {
        if (item && item.divider) {
            if (out.length === 0 || out[out.length - 1].divider) return; // leading / doubled
        }
        out.push(item);
    });
    while (out.length && out[out.length - 1].divider) out.pop(); // trailing
    return out;
};

export default tidyDividers;
